// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json__Decode from "../../../../node_modules/rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as Generic$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/utils/Generic.bs.js";
import * as Location$Showside from "./Location.bs.js";
import * as HistoryUtils$Showside from "./HistoryUtils.bs.js";
import * as LocalStorage$Showside from "./LocalStorage.bs.js";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as BrowserNavigation$Showside from "./BrowserNavigation.bs.js";
HistoryUtils$Showside.setScrollRestoration("manual");
function scrollPosition_encode(position) {
  if (typeof position === "number") {
    return Curry._2(Generic$ApiTypes.Encode.array, ["Zero"], Generic$ApiTypes.Encode.string);
  } else if (position.TAG === /* Pixels */0) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(position._0, "Pixels", Generic$ApiTypes.Encode.$$int);
  } else {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(position._0, "Index", Generic$ApiTypes.Encode.$$int);
  }
}
var zero = Json__Decode.map(Json__Decode.index(0, Generic$ApiTypes.Decode.exactString("Zero")), function (param) {
  return /* Zero */0;
});
var pixels = Generic$ApiTypes.Decode.deccoVariantWithPayload("Pixels", Json__Decode.$$int, function (v) {
  return {
    TAG: /* Pixels */0,
    _0: v
  };
});
var index = Generic$ApiTypes.Decode.deccoVariantWithPayload("Index", Json__Decode.$$int, function (v) {
  return {
    TAG: /* Index */1,
    _0: v
  };
});
var scrollPosition_decode = Json__Decode.oneOf(zero, [pixels, index]);
function set(key, value) {
  LocalStorage$Showside.set(undefined, {
    NAME: "scrollRestoration",
    VAL: key
  }, JSON.stringify(scrollPosition_encode(value)));
}
function $$delete(key) {
  LocalStorage$Showside.$$delete(undefined, {
    NAME: "scrollRestoration",
    VAL: key
  });
}
function get(key) {
  return Belt_Option.mapWithDefault(LocalStorage$Showside.get(undefined, {
    NAME: "scrollRestoration",
    VAL: key
  }), /* Zero */0, function (position) {
    var result = Json__Decode.decodeValue(JSON.parse(position), scrollPosition_decode);
    if (result.TAG === /* Ok */0) {
      return result._0;
    } else {
      return /* Zero */0;
    }
  });
}
var ScrollRestorationLocalStorage = {
  set: set,
  $$delete: $$delete,
  get: get
};
var scrollRestoration = {};
var pendingScrollLock = {
  contents: undefined
};
var breakingPoints = {
  contents: {}
};
function setScroll($$location, id, position) {
  var bucketKey = Location$Showside.toQueryString(undefined, Location$Showside.sanitizeLocation($$location));
  var bucket = Js_dict.get(scrollRestoration, bucketKey);
  set(id, position);
  if (bucket !== undefined) {
    Caml_option.valFromOption(bucket)[id] = position;
  } else {
    scrollRestoration[bucketKey] = Js_dict.fromArray([[id, position]]);
  }
}
function setBreakingPoint(paddingOpt, id, center) {
  var padding = paddingOpt !== undefined ? paddingOpt : 0;
  breakingPoints.contents[id] = {
    center: center,
    padding: padding
  };
}
function removeBreakingPoint(idToDelete) {
  breakingPoints.contents = Js_dict.fromArray(Belt_Array.keepMap(Js_dict.entries(breakingPoints.contents), function (param) {
    var id = param[0];
    if (id !== idToDelete) {
      return [id, param[1]];
    }
  }));
}
function getAllBreakingPoints(param) {
  return Belt_SortArray.stableSortBy(Js_dict.values(breakingPoints.contents), function (a, b) {
    if (a.center > b.center) {
      return 1;
    } else if (a.center < b.center) {
      return -1;
    } else {
      return 0;
    }
  });
}
function setCurrentScroll(namespace, id, target) {
  setScroll(Location$Showside.getStatesByNamespace(namespace).current, id, target);
}
function getClosestBreakingPoint(currentScroll, targetScroll) {
  var allPoints = getAllBreakingPoints(undefined);
  return Belt_Array.reduce(allPoints, targetScroll, function (prev, curr) {
    if ((curr.center - curr.padding | 0) <= currentScroll && (curr.center + curr.padding | 0) >= currentScroll) {
      return currentScroll;
    } else if (curr.center <= currentScroll) {
      return curr.center;
    } else {
      return prev;
    }
  });
}
function setScrollLock(dref) {
  Belt_Option.map(Caml_option.nullable_to_opt(dref.current), function (el) {
    pendingScrollLock.contents = {
      element: el,
      boundingClientRect: el.getBoundingClientRect()
    };
  });
}
function clearScrollLock(param) {
  pendingScrollLock.contents = undefined;
}
function getScroll(namespace, localStorage, id) {
  var bucketKey = Location$Showside.toQueryString(undefined, Location$Showside.sanitizeLocation(Location$Showside.getStatesByNamespace(namespace).current));
  var fromBucket = Belt_Option.flatMap(Js_dict.get(scrollRestoration, bucketKey), function (bucket) {
    return Js_dict.get(bucket, id);
  });
  if (fromBucket !== undefined) {
    return fromBucket;
  }
  if (!localStorage) {
    return /* Zero */0;
  }
  var fromLocalStorage = get(id);
  $$delete(id);
  return fromLocalStorage;
}
var blockingOnScrollEvent = {
  contents: false
};
function setBlockingOnScrollEvent(bool) {
  blockingOnScrollEvent.contents = bool;
}
function isBlockingOnScrollEvent(param) {
  return blockingOnScrollEvent.contents;
}
function useScrollRestoration(id) {
  var timeoutRef = React.useRef(undefined);
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var getInitialResult = function (localStorage) {
    return {
      position: Belt_Option.getWithDefault(Belt_Option.map(id, function (param) {
        return getScroll(namespace, localStorage, param);
      }), /* Zero */0),
      lock: undefined
    };
  };
  var getCurrentKey = function (param) {
    return Location$Showside.toQueryString(undefined, Location$Showside.sanitizeLocation(Location$Showside.getStatesByNamespace(namespace).current));
  };
  var key = React.useRef(getCurrentKey(undefined));
  React.useEffect(function () {
    return function (param) {
      Belt_Option.forEach(timeoutRef.current, function (prim) {
        clearTimeout(prim);
      });
    };
  }, []);
  var match$1 = React.useState(function () {
    return getInitialResult(false);
  });
  var setResult = match$1[1];
  var setResult$1 = function (fn) {
    blockingOnScrollEvent.contents = true;
    Curry._1(setResult, fn);
    timeoutRef.current = Caml_option.some(setTimeout(function (param) {
      blockingOnScrollEvent.contents = false;
    }, 100));
  };
  BrowserNavigation$Showside.useBrowserNavigation(function (navigationType) {
    if (navigationType !== 1) {
      return Belt_Option.forEach(id, $$delete);
    }
    var nextResult = getInitialResult(true);
    var match = nextResult.position;
    var nextResultValue = typeof match === "number" ? 0 : match._0;
    setResult$1(function (previousResult) {
      var match = previousResult.position;
      if (typeof match === "number" || match._0 < nextResultValue) {
        return nextResult;
      } else {
        return previousResult;
      }
    });
  }, []);
  React.useEffect(function () {
    setResult$1(function (param) {
      return getInitialResult(false);
    });
  }, [id]);
  var update = function (param) {
    if (id === undefined) {
      return;
    }
    var nextKey = getCurrentKey(undefined);
    if (key.current !== nextKey) {
      setResult$1(function (param) {
        return {
          position: getScroll(namespace, false, id),
          lock: pendingScrollLock.contents
        };
      });
      key.current = nextKey;
      return;
    }
  };
  React.useEffect(function () {
    Location$Showside.setLocalCallbacksByNamespace(namespace, Belt_Array.concat(Location$Showside.getStatesByNamespace(namespace).localCallbacks, [update]));
    return function (param) {
      Location$Showside.setLocalCallbacksByNamespace(namespace, Belt_Array.keep(Location$Showside.getStatesByNamespace(namespace).localCallbacks, function (fn) {
        return fn !== update;
      }));
    };
  }, []);
  return match$1[0];
}
export { scrollPosition_encode, scrollPosition_decode, ScrollRestorationLocalStorage, scrollRestoration, pendingScrollLock, breakingPoints, setScroll, setBreakingPoint, removeBreakingPoint, getAllBreakingPoints, setCurrentScroll, getClosestBreakingPoint, setScrollLock, clearScrollLock, getScroll, blockingOnScrollEvent, setBlockingOnScrollEvent, isBlockingOnScrollEvent, useScrollRestoration };
/*  Not a pure module */